import { render, staticRenderFns } from "./custom-person-report.vue?vue&type=template&id=c99e1dee&scoped=true"
import script from "./custom-person-report.vue?vue&type=script&lang=js"
export * from "./custom-person-report.vue?vue&type=script&lang=js"
import style0 from "./custom-person-report.vue?vue&type=style&index=0&id=c99e1dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99e1dee",
  null
  
)

export default component.exports